<script lang="ts">
  import type { MapTextbox } from "../../types";

  export let textbox: MapTextbox;
  export let isActive = false;

  $: icon = { id: textbox.id, src: textbox.iconSrc };
  $: size = textbox.iconSize;
  $: color = textbox.iconColor;
  $: x = textbox.iconOffset.x;
  $: y = textbox.iconOffset.y;
</script>

{#if icon}
  <span
    class="IconBar {textbox.textAlign}"
    class:active={isActive}
    draggable="false"
    style="--offset-x: {x}px; --offset-y: {y}px; --size: {size}px; --src: url({textbox.iconSrc}); --color: {textbox.iconColor}"
  >
    <div class="Mask" class:enabled={color}>
      <img
        class="Icon"
        alt=""
        aria-hidden="true"
        src={textbox.iconSrc}
        width={size}
        draggable="false"
      />
    </div>
  </span>
{/if}

<style>
  .IconBar {
    border-radius: calc(var(--size) * 0.5);
    display: block;
    height: max-content;
    position: absolute;
    width: var(--size);
  }

  .IconBar.active {
    --active-color: rgba(0, 0, 0, 0.2);
    --active-bleed: 4px;
    background: var(--active-color);
    box-shadow: 0 0 0 var(--active-bleed) var(--active-color);
  }

  .Icon {
    display: block;
  }

  .Mask.enabled {
    background: var(--color);
    mask-image: var(--src);
    mask-size: var(--size) auto;
  }

  .Mask.enabled .Icon {
    opacity: 0;
  }

  .center {
    left: calc(50% + var(--offset-x));
    top: var(--offset-y, 0);
    transform: translate(-50%, -100%);
  }

  .left {
    top: calc(50% + var(--offset-y));
    left: var(--offset-x);
    transform: translate(-100%, -50%);
  }

  .right {
    top: calc(50% + var(--offset-y));
    right: calc(var(--offset-x) * -1);
    transform: translate(100%, -50%);
  }
</style>
